module.exports = __webpack_public_path__ + "static/media/OverallGuideline3_sm1.2bf8f928.jpg";